/* @flow */
import axios from 'axios'
import lodash from 'lodash'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import { getLanguage } from '@/api/apps/request'
import i18nMsgs from '@/i18n'
import moment from 'moment'

export const langs = {
  enUS: 'en-US',
  zhCN: 'zh-CN',
}

export function isLanguageFeature (featureName) {
  for (let key in langs) {
    if (langs[key].toLowerCase() === featureName.toLowerCase()) {
      return true
    }
  }
  return false
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  messages: i18nMsgs,
  locale: 'en-US',
  fallbackLocale: 'en-US',
})

const loadedLanguages = new Set()

export function mergeLanguageMessages (backendMessages = {}, localeMessages = {}) {
  const messages = lodash.merge({}, backendMessages, localeMessages)
  const backendRegionalLabels = lodash.get(backendMessages, 'regionalLabels')

  if (backendRegionalLabels) {
    lodash.set(messages, 'regionalLabels', lodash.merge(
      {},
      lodash.get(localeMessages, 'regionalLabels', {}),
      backendRegionalLabels,
    ))
  }

  return messages
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  loadedLanguages.add(lang)
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export async function loadLanguageAsync (lang = 'en-US', { force = false } = {}) {
  const backendI18n = [
    'workPermitPreSetList.HK',
    'inspection.itemInspectedOptions.HK',
    'tenantConfirms.HK.topOfPage_p1',
    'tender.HK.PM.conditionsOfContracts',
    'terms.HK.tenantProjects.title',
    'termsAndConditions.HK.tenancy.contractorInfoRemark',
    'pmsrFooter.HK',
  ]
  const needsLoad = force || !loadedLanguages.has(lang) || backendI18n.some(item => !i18n.te(item))
  let messages
  if (needsLoad) {
    const backendMessages = await getLanguage(lang) || {}
    const langMsgs = i18n.getLocaleMessage(lang)
    messages = mergeLanguageMessages(backendMessages, langMsgs)
    i18n.setLocaleMessage(lang, messages)
  }
  setI18nLanguage(lang)
  moment.locale(lang)
  return { messages, lang }
}

export default i18n
